export const TOKEN = "token";
export const USER = "user";
export const JWT = "jwt";
export const USERTYPE = "userType";
